import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOverig = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M20 25a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
    />
    <path
      fill="#F8BADD"
      d="M9 23a3 3 0 1 0 0-6 3 3 0 0 0 0 6M31 23a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    />
    <path
      fill="#00215B"
      d="M13.243 25.243A5.98 5.98 0 0 1 9 27a5.98 5.98 0 0 1-4.243-1.757A5.98 5.98 0 0 1 3 21a5.98 5.98 0 0 1 1.757-4.243A5.98 5.98 0 0 1 9 15v1a4.98 4.98 0 0 0-3.536 1.465A4.98 4.98 0 0 0 4 21a4.98 4.98 0 0 0 1.464 3.535A4.98 4.98 0 0 0 9 26a4.98 4.98 0 0 0 3.536-1.465zM27 15.172A4.14 4.14 0 0 1 29.9 14a4.14 4.14 0 0 1 2.899 1.172A3.94 3.94 0 0 1 34 18a3.94 3.94 0 0 1-1.201 2.828 4.14 4.14 0 0 1-2.9 1.172v-1a3.14 3.14 0 0 0 2.202-.887c.573-.56.899-1.311.899-2.113s-.326-1.553-.9-2.113A3.14 3.14 0 0 0 29.9 15a3.14 3.14 0 0 0-2.202.887z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOverig);

export default ForwardRef;
